// The credit Book & pay will actually apply (26 Oct 2026). The server prices
// account credit only on evidence (Order::Pricing): this browser booked on
// the account before, or the mobile AND email typed here both belong to one
// paying customer (Credit::ContactMatch). The page asks
// POST /api/v2/credits/preview and shows "£X credit applied" for that and
// nothing else: never the whole balance of a signed-in account the server
// would not spend. Imports nothing, so node --test can run it.

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// The question to ask, or null when there is nothing worth asking yet: a
// signed-in payer always (their cookie may count), a guest once both the
// mobile and a whole email are typed.
export const previewQuery = ({ signedIn, mobile, email }) => {
  const m = String(mobile || '').trim()
  const e = String(email || '').trim().toLowerCase()
  const both = m.length >= 10 && EMAIL.test(e)
  if (!signedIn && !both) return null
  return both ? { mobile: m, email: e } : { mobile: '', email: '' }
}

export const previewKey = query => (query ? `${query.mobile}|${query.email}` : '')

// Pence of credit to show off this bill: what the server said, never more
// than the bill (the server takes it off the whole bill, tip included).
export const appliedCreditCents = (previewCents, billCents) => Math.max(0, Math.min(previewCents || 0, billCents || 0))
